import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Usage in translation json files:
 * - en.json (key: value):
 * "found results": "=0 {No results} =1 {One result} >1 {{{count}} results found}",
 * - pl.json (key: value):
 * "found results": "=0 {Brak rezultatów} =1 {Jeden rezultat} <5 {{{count}} rezultaty} other {{{count}} rezultatów}"
 *
 * Usage in component:
 * {{'pluralMapper.ticket' | translateSelector: { count: content.length }}}
 *
 * Results:
 * If items.length = 0: No results (en) Brak rezultatów (pl)
 * If items.length = 7: 7 results found (en) 7 rezultatów (pl)
 */
@Pipe({
  name: 'translateSelector',
  pure: false,
  standalone: false
})
export class TranslateSelectorPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(key: string, params: any): string {
    const firstParam: number | null = params && typeof Object.values(params)[0] === 'number' ? (Object.values(params)[0] as number) : null;
    let text = this.translateService.instant(key, params);
    if (!text || text === key){
      return key;
    }

    if (firstParam != null) {
      if (params) {
        Object.keys(params).forEach((paramKey) => {
          const regex = new RegExp(`{{${paramKey}}}`, 'g');
          text = text.replace(regex, params[paramKey]);
        });
      }

      const match = text.match(/(([=<>][^}]+|other|else) ?{([^}]+))}/g);
      if (match) {
        const ret = match.map((m) => m.match(/([=<>oe]) ?([^{]+) ?{([^}]+)}/)).find((f) => this.evalCondition(firstParam, f[1], f[2].trim()));
        if (ret) {
          return ret[3];
        }
      }
    }

    return text;
  }

  private evalCondition(left: number, operator: string, right: string): boolean {
    if (['o', 'e'].includes(operator)) return true;

    const rightNumber = parseInt(right, 10);
    if (isNaN(rightNumber)) return false;

    switch (operator) {
      case '=':
        return left === rightNumber;
      case '<':
        return left < rightNumber;
      case '>':
        return left > rightNumber;
    }
    return false;
  }
}
